<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <g id="Group_3802" data-name="Group 3802" transform="translate(-1232 -485)">
            <circle id="Ellipse_139" data-name="Ellipse 139" cx="25" cy="25" r="25" transform="translate(1232 485)" fill="#254150"/>
            <g id="Group_3414" data-name="Group 3414" transform="translate(-3368.727 593.395)">
                <path id="Path_719" data-name="Path 719" d="M4623.4-77.4a.851.851,0,0,1-.606-.247l-3.79-3.9a.878.878,0,0,1-.028-1.259.875.875,0,0,1,1.258-.028l2.777,1.981a.364.364,0,0,0,.536-.058l6.58-8.129a.881.881,0,0,1,1.244-.173.882.882,0,0,1,.172,1.244l-7.432,10.211a.9.9,0,0,1-.638.345.124.124,0,0,1-.074.016Z" transform="translate(-0.001 0)" fill="#fff"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "current-status"
}
</script>

<style scoped>

</style>
